namespace TabAurous.Production {
    export interface SplittingRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        BagNo?: string;
        UserId?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NoOfSubBag?: number;
        EachSubBagPieces?: number;
        EachSubBagParts?: number;
        EmployeeId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        Details?: SplittingItemsRow[];
    }

    export namespace SplittingRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Production.Splitting';
        export const deletePermission = 'Production:Splitting:Delete';
        export const insertPermission = 'Production:Splitting:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:Splitting:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            BagNo = "BagNo",
            UserId = "UserId",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NoOfSubBag = "NoOfSubBag",
            EachSubBagPieces = "EachSubBagPieces",
            EachSubBagParts = "EachSubBagParts",
            EmployeeId = "EmployeeId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Details = "Details"
        }
    }
}
